import React, { Component } from 'react';
import {
    Select, Col, Card, Input, Form,
} from 'antd';
import { Link } from 'react-router-dom';
import connect from 'react-redux/es/connect/connect';
import { SFButton } from '../../../../components/SF-UI';
import { editLocationCriteriaRequest } from '../redux/actions/edit_location_criteria.actions';
import { message_error } from '../../../../components/Message';

const { Option } = Select;
const FormItem = Form.Item;

export default connect(null, { editLocationCriteriaRequest })(class EditAdjustLocation extends Component {
    locationCriteriaDataChange = prevValue => (e) => {
        if (!e.target.value) {
            return;
        }
        if (e.target.value === prevValue) {
            return;
        }
        if (e.target.name === 'radius') {
            if (Number(e.target.value) === prevValue) {
                return;
            }
            if (isNaN(e.target.value)) {
                message_error('Radius must be a positive number');
                return;
            }
        }
        this.props.editLocationCriteriaRequest(this.props.configId, this.props.locationId, { [e.target.name]: e.target.value });
    }

    onChangePriority = (value) => {
        this.props.editLocationCriteriaRequest(this.props.configId, this.props.locationId, { priority: value });
    }

    render() {
        const {
            currentLCName, currentLCPostcode, currentLCRadius, currentLCPriority, currentLCLongitude, currentLCLatitude,
        } = this.props;

        return (
            <Col span={10}>
                <Card className="border-shadows">
                    <Form
                        layout="vertical"
                    >
                        <FormItem
                            label="Location Name"
                        >
                            <Input
                                type="text"
                                name="name"
                                placeholder="Enter location name"
                                onBlur={this.locationCriteriaDataChange(currentLCName)}
                                defaultValue={currentLCName}
                            />
                        </FormItem>
                        <FormItem
                            label="Postcode"
                        >
                            <Input
                                type="text"
                                name="postcode"
                                placeholder="Enter postcode"
                                onBlur={this.locationCriteriaDataChange(currentLCPostcode)}
                                defaultValue={currentLCPostcode}
                            />
                        </FormItem>
                        <FormItem
                            label="Priority"
                        >
                            <Select defaultValue={currentLCPriority} onChange={this.onChangePriority}>
                                <Option value="0">0</Option>
                                <Option value="1">1</Option>
                                <Option value="2">2</Option>
                                <Option value="3">3</Option>
                                <Option value="4">4</Option>
                                <Option value="5">5</Option>
                            </Select>
                        </FormItem>
                        <FormItem
                            label="Radius"
                        >
                            <Input
                                type="text"
                                name="radius"
                                placeholder="Enter radius"
                                onBlur={this.locationCriteriaDataChange(currentLCRadius)}
                                defaultValue={currentLCRadius}
                            />
                        </FormItem>
                        <FormItem
                            label="Latitude"
                        >
                            <Input
                                type="text"
                                name="coordinates.latitude"
                                placeholder="Enter latitude"
                                onBlur={this.locationCriteriaDataChange(currentLCLatitude)}
                                defaultValue={currentLCLatitude}
                            />
                        </FormItem>
                        <FormItem
                            label="Longitude"
                        >
                            <Input
                                type="text"
                                name="coordinates.longitude"
                                placeholder="Enter longitude"
                                onBlur={this.locationCriteriaDataChange(currentLCLongitude)}
                                defaultValue={currentLCLongitude}
                            />
                        </FormItem>
                    </Form>
                    <div className="sf-btn-toolbar">
                        <SFButton type="primary">
                            <Link to="/PlatformManagement/Lead-o-matic_update">
                                Back
                            </Link>
                        </SFButton>
                    </div>
                </Card>
            </Col>
        );
    }
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Lead-o-matic_location_update/components/EditAdjustLocation.js